import React, { useState, useEffect, useContext } from "react";
import "./CommonText.scss";
import ResumeUseForm from "../../../hooks/editor/resumeUseForm";
import ResumeSubUseForm from "../../../hooks/editor/resumeSubUseForm";
import { ResumePopupContext } from "../../../Context/resumePopupContext";
import { useTranslation } from "react-i18next";
import InputEditable from "../../ContentEditable/InputEditable";
import Dragicon from "../../Dragicon/Dragicon";
import DeleteButton from "../../Buttons/ResumeDeleteButton/DeleteButton";
import { Accordion } from "react-bootstrap";
import ArrowAccordion from "../../Accordion/ArrowAccordion";
import CommonTextItem from "./CommonTextItem";
import ResumeButton from "../../Buttons/ResumeButton/ResumeButton";
import EditorAccordian from "../../Accordion/EditorAccordian/EditorAccordian";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

function Education({
  resumeHandler,
  resumeUpdate,
  addResumeField,
  sectionId,
  resumeFields,
  showHideElements,
  setResumeFields,
  setModalShow,
  styles,
  settings,
  resumeTitleHandler,
  handleEditorChange,
  resumeTitleRemove,
  dateHandler,
  deletePopupShow,
  handleItemDelete,
  languageHandler,
  resumeAllFields,
}) {
  const [t, i18n] = useTranslation("common");
  const [active, setActive] = useState("0");

  const { showPopup, arrayIndex } = useContext(ResumePopupContext);

  const activeAccordian = (value) => {
    if (active == value) {
      setActive("");
    } else {
      setActive(value);
    }
  };
  const setDotValue = (value) => [];

  const addResumeField1 = (ref, value, section) => {
    addResumeField(ref, value, section);
    if (sectionId != "profile") {
      setTimeout(() => {
        // changeFocusStyle(sectionId, value.length.toString(), "item");
        const element = document.getElementsByClassName(
          `basic-scroll-${sectionId}`
        );

        if (element && element[0]) {
          element[0].scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });
        }
        activeAccordian(
          (
            resumeFields &&
            resumeFields.data &&
            resumeFields.data.length - 1
          ).toString()
        );
      }, 350);
    }
  };

  return (
    <>
      <div className={`card mb-4 section-card basic-scroll-${sectionId}`}>
        {!showPopup && (
          <div className="card-header d-flex justify-content-between align-items-center bg-white">
            <h4 className="card-title d-flex">
              <InputEditable
                sectionId={sectionId}
                resumeFields={resumeFields}
                onBlur={resumeTitleHandler}
                name="customTitle"
                onRemove={resumeTitleRemove}
              />
            </h4>
            <div className="d-flex">
              {/* <ResumeButton
                primary
                switch
                alt="plus"
                title="Show Section"
                className="mr-3"
                id="education"
                checked={resumeFields.show}
                onChange={handleShowSection}
              /> */}
              <ResumeButton
                left
                left_icon
                primary
                src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/trash.svg`}
                alt="plus"
                title="Delete"
                className="mr-3"
                onClick={() => deletePopupShow("layout", sectionId)}
              />
              {!showPopup && (
                <ResumeButton
                  left
                  left_icon
                  primary
                  src="/images/plusgreen.svg"
                  alt="plus"
                  title={`Add ${t(`${sectionId}.defaultTitle`)}`}
                  onClick={() => {
                    addResumeField1("ref", "value", sectionId);
                    setActive(`${resumeFields.data.length}`);
                  }}
                />
              )}
            </div>
          </div>
        )}
        {resumeFields && resumeFields.show && (
          <div className="card-body">
            <form>
              <div className="">
                <Accordion defaultActiveKey="0" activeKey={active}>
                  <DragDropContext
                  //   onDragEnd={handleOnDragEnd}
                  >
                    <Droppable droppableId={sectionId}>
                      {(provided) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                        >
                          <label className="">
                            If relevant, include your most recent educational
                            achievements and dates here.
                          </label>
                          &nbsp;
                          {resumeFields &&
                            resumeFields.data &&
                            resumeFields.data.map((res, index) => {
                              if (showPopup && arrayIndex !== index) {
                                return null;
                              }

                              return (
                                <Draggable
                                  key={`${sectionId}${index}`}
                                  draggableId={`${sectionId}${index}`}
                                  index={index}
                                >
                                  {(provided) => (
                                    <div
                                      className="sep-workexp "
                                      key={`${sectionId}${index}`}
                                      ref={provided.innerRef}
                                      // onClick={() => innerSectionClick(index)}
                                      {...provided.draggableProps}
                                    >
                                      <>
                                        <EditorAccordian
                                          resumeFields={resumeFields}
                                          active={active}
                                          res={res}
                                          heading_empty={`${t(
                                            `${sectionId}.defaultTitle`
                                          )}`}
                                          heading={res.degree}
                                          content={res.school}
                                          index={index}
                                          provided={provided}
                                          setActive={activeAccordian}
                                        >
                                          <CommonTextItem
                                            resumeHandler={(e) =>
                                              resumeHandler(
                                                e,
                                                index,
                                                "basic",
                                                sectionId
                                              )
                                            }
                                            resumeUpdate={resumeUpdate}
                                            handleEditorChange={
                                              handleEditorChange
                                            }
                                            index={index}
                                            sectionId={sectionId}
                                            res={res}
                                            dateHandler={dateHandler}
                                            handleItemDelete={() =>
                                              handleItemDelete(index, sectionId)
                                            }
                                            setDotValue={setDotValue}
                                            languageHandler={languageHandler}
                                            resumeAllFields={resumeAllFields}
                                            setResumeFields={setResumeFields}
                                            // handleDelete={() =>
                                            //   handleDelete(index)
                                            // }

                                            // handleEditorChange={
                                            //   handleEditorChange
                                            // }
                                            // resumeUpdateCancel={
                                            //   resumeUpdateCancel
                                            // }

                                            // setSaveIndex={() =>
                                            //   setSaveIndex(index)
                                            // }

                                            // saveIndex={saveIndex}

                                            // dateHandler={dateHandler}
                                          />
                                        </EditorAccordian>
                                      </>
                                    </div>
                                  )}
                                </Draggable>
                              );
                            })}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </Accordion>
              </div>
            </form>
          </div>
        )}
      </div>
    </>
  );
}

export default Education;
